<template>
  <div class="container-lg">
    <h1 class="page-header">Document template</h1>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="handleSubmit()" name="form">
        <div class="form-group row">
          <label class="col-md-3">Template name</label>
          <div class="col-md-9">
            <ValidationProvider name="template name" rules="required" v-slot="{ errors }">
              <input class="form-control" type="text" v-model="item.name" />
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3">Reference document</label>
          <div class="col-md-6">
            <ValidationProvider name="reference document" rules="required" v-slot="{ errors }">
              <select class="form-control" v-model="item.refdoc">
                <option v-for="o in refdocOptions" :value="o.name" :key="o.name">{{ o.value }}</option>
              </select>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3">HTML Document</label>
          <div class="col-md-9">
            <ValidationProvider name="html document" rules="required" v-slot="{ errors }">
              <textarea class="form-control" type="text" v-model="item.html" rows="25"></textarea>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-3"></div>
          <div class="col-md-3">
            <button class="btn btn-danger" type="button" @click="Delete()">Delete</button>
          </div>
          <div class="col-md-6 text-right">
            <button class="btn btn-light mr-4" type="button" @click="$router.back()">Cancel</button>
            <button class="btn btn-primary" type="submit" :disabled="invalid">Save</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { authFetch } from "../lib/auth.js";

export default {
  props: {
    id: String,
  },
  data() {
    return {
      item: {
        // Add fields here so vue watches all fields for changes
        name: "",
        html: "",
        refdoc: "",
      },
      refdocs: [],
    };
  },
  created() {
    this.load();
  },
  watch: {
    id() {
      this.load();
    },
  },
  computed: {
    refdocOptions() {
      const opts = this.refdocs.map((d) => {
        return { name: d, value: d };
      });
      if (this.item.refdoc && !opts.find((o) => this.item.refdoc == o.name)) {
        opts.push({
          name: this.item.refdoc,
          value: this.item.refdoc + " [file missing]",
        });
      }
      opts.sort((a, b) => a.name.localeCompare(b.name));
      return opts;
    },
  },
  methods: {
    Delete() {
      if (confirm("Delete! Are you sure?") === true) {
        authFetch("/db/template/" + this.item.id, {
          method: "delete",
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              this.$router.back();
              return;
            default:
              resp.text().then((text) => alert(resp.statusText + text));
          }
        });
      }
    },
    handleSubmit() {
      if (this.item.id) {
        // Update existing
        authFetch("/db/template/" + this.item.id, {
          method: "put",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              this.$router.back();
              return;
            default:
              resp.text().then((text) => alert(resp.statusText + text));
          }
        });
      } else {
        authFetch("/db/template", {
          method: "post",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              resp.text().then((id) => {
                this.item.id = parseInt(id);
              });
              this.$router.back();
              return;
            default:
              resp.text().then((text) => alert(resp.statusText + ":" + text));
          }
        });
      }
    },
    load() {
      authFetch("/template/refdocs")
        .then((resp) => resp.json())
        .then((data) => (this.refdocs = data));
      if (!this.id) {
        Object.assign(this.item, {
          id: null,
          name: "",
        });
        return;
      } else {
        authFetch("/db/template/" + this.id)
          .then((resp) => resp.json())
          .then((data) => {
            Object.assign(this.item, data);
          });
      }
    },
  },
};
</script>

<style lang="scss">
</style>